import {connect} from '../../app/connect';
import ProjectList from './ProjectList';

import {changeLocationAction, setQueryParamsAction, navigateToIssueInDocumentAction} from '../../app/actions';
import {
  getFetchParams,
  getDocumentCollection,
  getFetchingIssuesUrns,
  getIsLocationsTreeLoading,
  getIsLocationsLoadingError,
  getLocationsTreeNodes,
  isMinimalTableColumns,
  getCurrentUserInMcFormat,
  getAllOxygenMappings,
  getFieldIssueTypesAndSubTypesIdToTitleMap,
  getIssueRootCausesDefinitionsEntitiesMap,
  getChecklistCollection,
  getFetchingChecklistInstances
} from '../../app/selectors';

const mapStateToProps = state => ({
  fetchParams: getFetchParams(state),
  documentCollection: getDocumentCollection(state),
  fetchingIssuesUrns: getFetchingIssuesUrns(state),
  isLocationsTreeLoading: getIsLocationsTreeLoading(state),
  isLocationsLoadingError: getIsLocationsLoadingError(state),
  locationsTreeNodes: getLocationsTreeNodes(state),
  rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state),
  issueTypesAndSubTypesTitleMap: getFieldIssueTypesAndSubTypesIdToTitleMap(state),
  isMinimalTableColumns: isMinimalTableColumns(state),
  currentUser: getCurrentUserInMcFormat(state),
  oxygen: getAllOxygenMappings(state),
  checklistCollection: getChecklistCollection(state),
  fetchingChecklistInstances: getFetchingChecklistInstances(state)
});

export default connect(
  mapStateToProps,
  {
    changeLocationAction,
    setQueryParamsAction,
    navigateToIssueInDocumentAction
  }
)(ProjectList);
